export const THEME_STORAGE_KEY = "genmechThemePreference";

export const THEME_OPTIONS = [
  { value: "system", label: "System Default" },
  { value: "light", label: "Light" },
  { value: "dark", label: "Dark" }
];

export const getStoredThemePreference = () => {
  if (typeof window === "undefined") return "system";
  const stored = String(window.localStorage.getItem(THEME_STORAGE_KEY) || "system").trim().toLowerCase();
  return ["light", "dark", "system"].includes(stored) ? stored : "system";
};

export const getResolvedTheme = (preference) => {
  if (preference === "light" || preference === "dark") {
    return preference;
  }

  if (typeof window !== "undefined" && window.matchMedia) {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  }

  return "light";
};

export const applyThemePreference = (preference) => {
  if (typeof document === "undefined") return;

  const nextPreference = ["light", "dark", "system"].includes(preference) ? preference : "system";
  const resolvedTheme = getResolvedTheme(nextPreference);
  const root = document.documentElement;

  root.dataset.themePreference = nextPreference;
  root.dataset.theme = resolvedTheme;

  if (typeof window !== "undefined") {
    window.localStorage.setItem(THEME_STORAGE_KEY, nextPreference);
  }
};
